import { ERentioFormField } from "../../components/components/Form";
import { contactSelectInlineV2ValueSelector, getValue, } from "../../redux/form/form.utils";
import { EContractMemberTypes } from "../../types/contract.types";
import { ELocale } from "../../types/i18n.types";
import { getAllRequiredCompanyFields, getAllRequiredContactFields, } from "../../utils/forms.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField as EContactField } from "../addContact/schema.addContact.types";
import { EField } from "./schema.createRentDeposit.types";
import { getNavigationTitle } from "./schema.createRentDeposit.utils";
var getSignersFieldProps = function (extraData) {
    return {
        "ui:field": ERentioFormField.ContactSelectInlineV2,
        title: getLocalizedText("rent_deposit.signers.label"),
        isMultiSelect: true,
        asOptionList: true,
        getRequiredContactFieldsSchema: function (contact) {
            return getAllRequiredContactFields({
                contact: contact,
                requiredFields: [
                    EContactField.Address,
                    EContactField.DateOfBirth,
                    EContactField.Nationality,
                    EContactField.PlaceOfBirth,
                ],
                appendIdentityNumberToRequiredFields: true,
            });
        },
        getRequiredCompanyFieldsSchema: function (contact) {
            return getAllRequiredCompanyFields({
                contact: contact,
                requiredFields: [
                    EContactField.Address,
                    EContactField.DateOfBirth,
                    EContactField.Nationality,
                    EContactField.PlaceOfBirth,
                    EContactField.VATNumber,
                ],
                appendIdentityNumberToRequiredFields: true,
            });
        },
        valueSelector: function (state, selectedAccountIds, formData) {
            var _a;
            if (selectedAccountIds === void 0) { selectedAccountIds = []; }
            return contactSelectInlineV2ValueSelector(state, selectedAccountIds, ((_a = extraData.contract) === null || _a === void 0 ? void 0 : _a.members.map(function (member) { return member.account; })) || []);
        },
        customGetSubtitleSelector: function (_, formData, item) {
            var accountId = item.accountId, contact = item.contact;
            var member = extraData.contract.members.find(function (member) {
                if (accountId && accountId === member.account.id) {
                    return true;
                }
                if (contact === null || contact === void 0 ? void 0 : contact.accountIds.includes(member.account.id)) {
                    return true;
                }
                return false;
            });
            if (!member) {
                return;
            }
            return member.roles
                .map(function (role) { return getLocalizedText("role.".concat(role.toLowerCase())); })
                .join(", ");
        },
        customExtraAccountsSelector: function (_, formData) {
            var contractMembers = extraData.contract.members
                .filter(function (member) {
                return member.roles.some(function (role) {
                    return [
                        EContractMemberTypes.Tenant,
                        EContractMemberTypes.Parent,
                    ].includes(role);
                });
            })
                .map(function (member) { return member.account; });
            return contractMembers;
        },
        customIsFetchingSelector: function () { return false; },
        customGetContactsActions: [],
        getDisallowedAccountIds: function (_) {
            return extraData.contactMeMaster && extraData.isBroker
                ? [extraData.contactMeMaster.account.id]
                : [];
        },
    };
};
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        return {
            required: [EField.TenantSigners],
            properties: (_a = {},
                _a[EField.Header + "2"] = {
                    default: undefined,
                },
                _a[EField.LegalContactInfo] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (formData) {
                        return extraData.isBroker && !extraData.legalContact;
                    },
                },
                _a[EField.TenantSigners] = {
                    default: getValue(EField.TenantSigners, initialValues, defaultValues),
                },
                _a[EField.Locale] = {
                    default: getValue(EField.Locale, initialValues, defaultValues),
                    // @ts-ignore
                    options: [ELocale.NL, ELocale.FR].map(function (locale) { return ({
                        id: locale,
                        value: getLocalizedText("system.locale.".concat(locale)),
                    }); }),
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:title": getLocalizedText("rent_deposit.signers.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "2"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.signers.heading"),
        },
        _a[EField.LegalContactInfo] = {
            "ui:field": ERentioFormField.HelpInfo,
            type: "warning",
            title: getLocalizedText("document_package.form.no_legal_contact_info.heading"),
            subtitle: getLocalizedText("document_package.form.no_legal_contact_info.content"),
        },
        _a[EField.TenantSigners] = getSignersFieldProps(extraData),
        _a[EField.Locale] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("document_package.form.locale.title"),
            formatSummary: function (formData) {
                return getLocalizedText("system.locale.".concat(formData || ELocale.NL));
            },
        },
        _a);
};
export var getValidate = function (extraData) { return function (formData, errors) {
    var _a;
    var tenants = extraData.contract.members.filter(function (member) {
        return member.roles.some(function (role) {
            return [EContractMemberTypes.Tenant, EContractMemberTypes.Parent].includes(role);
        });
    });
    if (tenants.length !== ((_a = formData[EField.TenantSigners]) === null || _a === void 0 ? void 0 : _a.length) &&
        errors[EField.TenantSigners]) {
        errors[EField.TenantSigners].addError(getLocalizedText("rent_deposit.signers.error.all_tenants.required"));
    }
    return errors;
}; };
